import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import FetchHook from "../../Api/FetchHooks";
import TableComponent from "../../Components/TableComponent";
import moment from "moment";
import PageLoader from "../../Components/PageLoader";
import { LoadingButton } from "@mui/lab";
import PutHooks from "../../Api/PutHook";
import { useForm } from "react-hook-form";
import AlertComponent from "../../Components/AlertComponent";
import ActionDialog from "../../Components/ActionDialog";
import UseServerTable from "../../Hooks/UseServerTable";
import { AllInbox } from "@mui/icons-material";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { formatCurrencyV2, formatDate } from "../../utils/helpers";

const WithdrawRequests = () => {
  // const [loading, response, request] = FetchHook();

  const [status, setStatus] = useState("");
  const [data, setData] = useState([]);
  const [poolRequest, setPoolRequest] = useState();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const fetchData = useCallback(async () => {
  //   await request({
  //     url: `/pool_fund_request?status=${status}`,
  //   });
  // }, [status]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response && response.data.StatusCode === 0) {
  //     setData(response.data.PoolFund);
  //   }
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/pool_fund_request?status=${status}`,
    onSuccess: (data) => {
      setData(data.PoolFund);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "#",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "entity_id",
      headerName: "Entity id",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 1,
    //   minWidth: 200,
    // },
    {
      field: "active_status",
      headerName: "Active Status",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 350,
    },
    {
      field: "start_date",
      headerName: "Start date",
      flex: 1,
      minWidth: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "Action",
      headerName: "",
      renderCell: (row) => (
        <>
          {/* {row.row.active_status === "pending" && ( */}
          <Button
            variant="outlined"
            onClick={() => {
              setPoolRequest(row.row);
              openDialog("pool_withdraw_approval", "Pool withdraw approval");
            }}
          >
            Action
          </Button>
          {/* )} */}
        </>
      ),
    },
  ];

  return (
    <Box sx={{ padding: "20px" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        data={poolRequest}
        onSuccess={refresh}
      />

      <Card>
        <CardHeader
          title={<Typography variant="h6">Pool withdraw requests</Typography>}
          action={
            <FormControl sx={{ width: "200px" }}>
              <InputLabel id="status" size="small">
                Status
              </InputLabel>

              <Select
                labelId="status"
                id="status"
                value={status}
                label="status"
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                size="small"
              >
                <MenuItem value="accepted">Accepted</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
              </Select>
            </FormControl>
          }
        />

        <CardContent>
          {data && data.length > 0 ? (
            <>
              <TableComponent
                data={data}
                columns={columns}
                sortModel={[
                  {
                    field: "start_date",
                    sort: "desc",
                  },
                ]}
                {...gridProps}
              />
            </>
          ) : gridProps.loading ? (
            <PageLoader />
          ) : (
            <ErrorDisplay
              message="You have no withdraw requests!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default WithdrawRequests;
